<template>
    <b-container class="container">
        <b-row>
            <h1>Alkoholfreie Getränke</h1>
        </b-row>
        <b-row>
            <b-col>
                <b-table striped hover stacked="md" :items="items" :fields="fields"></b-table>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'alcoholFree',
    props: {
        items: {
            type: String
        }
    },
    data() {
        return {
            fields: [
                {
                    key: "volume",
                    label: 'Inhalt',
                    sortable: true,
                    formatter: (value) => {
                        return value + " ltr.";
                    } 
                },
                {
                    key: "content",
                    label: 'Getränk'
                },
                {
                    key: "glas_025",
                    label: 'Glas',
                    sortable: true,
                    class: 'text-center',
                    formatter: (value) => {
                        if (value <= 0) {
                            return "-";
                        }

                        return Number(value).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
                    }    
                },
                {
                    key: "bottle",
                    label: 'Flasche',
                    sortable: true,
                    class: 'text-center',
                    formatter: (value) => {
                        if (value <= 0) {
                            return "-";
                        }

                        return Number(value).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
                    }    
                }
            ]
        }
    }
}
</script>

<style scoped style="sass">

</style>
